import schema from "./schema";
import React from "react";
import { cellErrors } from "@/react/components/table/useTableMutations";
import { EditableSelectCell } from "@/react/components/table/components/cells";
import { ValidationWrapper } from "@/react/components/table/components";
import { PHONE_CHANNEL_TYPES } from "@/react/features/vcc/phone-channels/constants";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";

export const PhoneChannelFormatCell = (phoneChannelFormatCell) => {
  const errors = cellErrors(phoneChannelFormatCell);

  if (!phoneChannelFormatCell.row) {
    return phoneChannelFormatCell.getValue();
  }

  const typeCell = phoneChannelFormatCell.row
    ?.getAllCells()
    .find((c) => c.column.id === schema.fields.type.spec.key)
    ?.getContext();

  const isFormatEditable = typeCell.getValue() !== PHONE_CHANNEL_TYPES.TENANT;

  return (
    <FullWidthDiv>
      <ValidationWrapper errors={errors}>
        {isFormatEditable ? (
          phoneChannelFormatCell.getValue()
        ) : (
          <EditableSelectCell {...phoneChannelFormatCell} />
        )}
      </ValidationWrapper>
    </FullWidthDiv>
  );
};
